export default __webpack_public_path__ + "static/media/pdf-solid-black.4e8f01e8.svg";